import { Navigate } from "react-router-dom";

// Ancien écran "Offre Premium" (placeholder + "contacte-nous pour payer") supprimé :
// il orientait vers un paiement hors-app, non conforme App Store (3.1.1) et incomplet (2.1).
// Toute la logique d'abonnement vit désormais dans /upgrade (Stripe sur web, RevenueCat sur mobile).
export const Premium = () => <Navigate to="/upgrade" replace />;

export default Premium;
